import { render, staticRenderFns } from "./eshop-item.vue?vue&type=template&id=31dd69f8&scoped=true&"
import script from "./eshop-item.vue?vue&type=script&lang=js&"
export * from "./eshop-item.vue?vue&type=script&lang=js&"
import style0 from "./eshop-item.vue?vue&type=style&index=0&id=31dd69f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd69f8",
  null
  
)

export default component.exports